import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Dialog from "@/view/components/Dialog";
import TextInput from "@/view/components/TextInput";
import { PATCH } from "@/core/services/store/request.module";
export default {
  name: "unlock-dialog",
  props: {
    unlockDialog: {
      type: Boolean,
      default: false
    },
    toBeUnlock: {
      type: Object,
      default: function _default() {
        return {
          uuid: null,
          type: null,
          name: null,
          created: {
            datetime: null
          }
        };
      }
    }
  },
  data: function data() {
    return {
      password: null,
      loading: false,
      show_password: false
    };
  },
  watch: {
    unlockDialog: function unlockDialog(param) {
      if (param) {
        this.password = null;
      }
    }
  },
  methods: {
    unlock_folder: function unlock_folder() {
      var _this = this;

      this.loading = true;
      this.$store.dispatch(PATCH, {
        url: "folders/".concat(this.toBeUnlock.uuid, "/unlock"),
        data: {
          password: this.password
        }
      }).then(function () {
        _this.$emit("close", true);

        _this.$emit("success", true);
      }).catch(function (error) {
        console.log({
          error: error
        });
      }).finally(function () {
        _this.loading = false;
      });
    }
  },
  components: {
    Dialog: Dialog,
    "text-input": TextInput
  }
};